import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";
import { TabPaneStatusEnum } from "typings/global.types";

const { Item } = Form;

export const FormItem = styled(Item)`
  margin-top: 15px;
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-form-item-label {
    text-align: start;
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content > textarea {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    &:hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    }
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }

  .ant-form-item-control-input-content > .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }

  .ant-form-item-control-input-content > textarea:hover:disabled {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }
`;

export const InputCustomPlate = (plateFormatType?: 0 | 1 | 2): CSSProperties => ({
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
  width: plateFormatType === 1 ? "140px" : plateFormatType === 2 ? "130px" : "120px",
  padding: plateFormatType === 1 ? "0 12px" : "0 8px",
  letterSpacing: plateFormatType === 1 ? "1px" : "0.5px",
});

export const FormPlateItem = styled(Item)`
  .ant-input,
  [] {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    max-width: ${({ plateFormatType }) => {
      switch (plateFormatType) {
        case 1:
          return "100px"; // Custom (até 10 chars)
        case 2:
          return "95px"; // México (até 9 chars)
        default:
          return "80px"; // BR (7 chars)
      }
    }};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-input-affix-wrapper > input.ant-input {
    text-transform: uppercase;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
    > span {
      pointer-events: auto;
    }
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:active,
    input:-webkit-autofill:focus {
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      color: ${(props) => props.theme["@secondary-color"]} !important;
      box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
      -webkit-box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
    }

    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }
`;

export const PlateField: CSSProperties = {
  width: "33%",
};

export const ShippingCompanyField: CSSProperties = {
  width: "100%",
};

export const ProcessesSelectFormItem: CSSProperties = {
  width: "100%",
  height: theme["@height-input-lg"],
  marginBottom: "58px",
};

export const ProcessesSelect: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const DrawerContent = styled.div`
  height: 100%;
  .ant-tabs-content {
    height: ${(props) => (props.tabPaneActive === TabPaneStatusEnum.Items && props.itemsCheckin?.length === 0 ? `none` : `100%`)};
  }
  .ant-tabs-ink-bar {
    background-color: ${(props) => props.theme["@primary-color-brand"]};
  }
  .ant-tabs-nav {
    margin-top: -23px;
  }
`;

export const InputPlate: CSSProperties = {
  textTransform: "uppercase",
  height: theme["@height-input-lg"],
};

export const InputCarrier: CSSProperties = {
  height: theme["@height-input-lg"],
};

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: ${(props) => (props.hasEntryPermission ? "1fr 1px 1fr 1px 0.7fr" : "1fr 1px 1fr")};
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
  .divider {
    background-color: ${(props) => props.theme["@input-border-color"]};
  }
  .ant-tabs-content {
    height: 100%;
  }
`;

export const DriverContainer = styled.div`
  display: grid;
  gap: 2px;
  margin-bottom: 10px;
`;

export const VehicleContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  margin-bottom: 10px;
`;

export const DescriptionName = styled.span`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
`;

export const DescriptionTitle = styled.span`
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
`;

export const DriverImage = styled.div`
  margin-bottom: 8px;
  display: grid;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  font-size: 16px;
`;

export const CheckContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  align-items: center;
  height: 90%;
  gap: 10px;
  .spin {
    margin-bottom: 20px;
  }
`;

export const DriverAndVehicleCheckContainer = styled.div`
  margin-top: 20px;
  height: auto;

  .btn-check {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: auto;
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme.colors.text} !important;
    border-radius: ${(props) => props.theme["@border-radius-base"]};
    height: 48px !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }
`;

export const TitleDriverCheck = styled.div`
  font-size: 20px;
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
`;

export const DescriptionNameDriverCheck = styled.span`
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: 20px;
  align-items: center;
  text-align: center;
`;

export const DriverCheckContainer = styled.div`
  .status {
    display: flex;
    padding: 8px 16px;
    width: 122px;
    text-align: center;
    justify-content: center;
    gap: 4px;
    border-radius: 300px;
    border-color: ${(props) => (props.released ? (props) => props.theme["@color-positive-100"] : (props) => props.theme["@color-danger-100"])};
    background-color: ${(props) => (props.released ? (props) => props.theme["@color-positive-100"] : (props) => props.theme["@color-danger-100"])};
    font-size: 14px;
    font-weight: 600;
    align-content: center;
    span {
      color: ${(props) => (props.released ? props.theme["@color-positive-600"] : props.theme["@color-danger-600"])};
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
    }
  }
`;

export const PlateContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const FakeBtnConfirm = {
  display: "none",
};

export const Driver = styled.div`
  margin-top: 15px;
  margin-bottom: 0;
  > label > span:nth-child(2) {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
`;

export const VehicleInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 3px;
`;

export const SaleChannelFormItem: CSSProperties = {
  width: "100%",
  marginTop: 0,
};

export const SaleChannelSelect: CSSProperties = {
  color: theme.colors.text,
  fontFamily: theme["@font-family"],
};

export const DocumentNumber = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.06fr;
  cursor: pointer;
  align-items: center;
  height: 52px;
  margin-left: 10px;
  margin-right: 10px;
  .divider {
    background-color: ${(props) => props.theme["@input-border-color"]};
    height: 1px;
    margin-top: 5px;
  }
`;

export const DocumentContainer = styled.div`
  margin-bottom: 15px;
  :hover {
    background-color: ${(props) => props.theme["@hover-input-wrapper"]};
  }
  .divider {
    background-color: ${(props) => props.theme["@input-border-color"]};
    height: 1px;
  }
`;

export const DocumentTitle = styled.div`
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
`;

export const ItemDescription = styled.div`
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  font-size: ${(props) => props.theme["@medium-font-size"]};
`;

export const ItemTitle = styled.div`
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  font-size: 18px;
`;
export const ItemHeader = styled.div`
  margin-bottom: 15px;
`;

export const ItemsTable = styled.div`
  max-height: 310px;
  overflow: auto;
`;

export const Document = styled.div`
  outline: ${(props) => (props.isActive ? `2px solid ${props.theme["@primary-color-brand"]}` : "none")};
  border-radius: 4px;
  margin-bottom: 2px;
`;

export const WithoutDocumentContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 44px;
`;
